import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  loading: false,
  holidaysLoading: false,
  error: null,
  holidays: [],
  storeHoliday: {},
  storeBranchHoliday: null,
};
const holidaysSlice = createSlice({
  name: 'holidays',
  initialState,
  reducers: {
    loadHolidaysRequested(state, action: PayloadAction<{}>) {
      state.holidaysLoading = true;
      state.error = null;
    },
    loadHolidaysSuccess(state, action: PayloadAction<any>) {
      state.holidaysLoading = false;
      state.error = null;
      state.holidays = action?.payload?.result?.results;
      state.paginationOption = {
        page: action.payload?.result?.page,
        pageSize: action.payload?.result?.pageSize,
        totalItems: action.payload?.result?.totalItems,
        numberOfPages: action.payload?.result?.numberOfPages,
      };
    },
    loadHolidaysFail(state, action: PayloadAction<{}>) {
      state.holidaysLoading = false;
      state.error = action.payload;
    },

    storeHolidayRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    storeHolidaySuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.storeHoliday = action.payload;
    },
    storeHolidayFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
    storeBranchHolidayRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    storeBranchHolidaySuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.storeBranchHoliday = action.payload;
    },
    storeBranchHolidayFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
    updateHolidayRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    updateHolidaySuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.updateHoliday = action.payload;
    },
    updateHolidayFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
    deleteHolidayRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    deleteHolidaySuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.deleteeHoliday = action.payload;
    },
    deleteHolidayFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
    deleteBranchHolidayRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    deleteBranchHolidaySuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.deleteBranchHoliday = action.payload;
    },
    deleteBranchHolidayFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  loadHolidaysRequested,
  loadHolidaysSuccess,
  loadHolidaysFail,
  storeBranchHolidayRequested,
  storeBranchHolidaySuccess,
  storeBranchHolidayFail,
  storeHolidayRequested,
  storeHolidaySuccess,
  storeHolidayFail,
  updateHolidayRequested,
  updateHolidaySuccess,
  updateHolidayFail,
  deleteHolidayRequested,
  deleteHolidaySuccess,
  deleteHolidayFail,
  deleteBranchHolidayRequested,
  deleteBranchHolidaySuccess,
  deleteBranchHolidayFail,
} = holidaysSlice.actions;

export default holidaysSlice.reducer;
